:host {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  user-select: none;
}

.back-button {
  border: none;
  outline: none;
  padding: 0;
  border-radius: 100%;
  background-color: var(--vx-back-button-background-color, var(--mdc-theme-primary, #f5f3f3));
  width: var(--vx-back-button-circle-radius, var(--mdc-icon-size, 48px));
  height: var(--vx-back-button-circle-radius, var(--mdc-icon-size, 48px));
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease-in;
}
.back-button:hover {
  background-color: var(--vx-back-button-background-hover-color, var(--mdc-theme-primary, #eaeaea));
}
.back-button:active {
  background-color: var(--vx-back-button-background-active-color, var(--mdc-theme-primary, #dedede));
}
.back-button:focus-visible {
  outline: -webkit-focus-ring-color auto 1px;
}
.back-button vx-icon {
  width: calc(var(--mdc-icon-size, 48px) / 2);
  height: calc(var(--mdc-icon-size, 48px) / 2);
}